import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const UbuntuColor = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      fill="#F47421"
    />
    <path
      d="M14.2439 5.44354C13.8752 6.08206 14.094 6.89852 14.7325 7.26717C15.371 7.63582 16.1875 7.41705 16.5561 6.77853C16.9248 6.14002 16.706 5.32355 16.0675 4.9549C15.429 4.58626 14.6125 4.80503 14.2439 5.44354Z"
      fill="white"
    />
    <path
      d="M6.535 12C6.535 12.7373 5.9373 13.335 5.20001 13.335C4.46271 13.335 3.86502 12.7373 3.86502 12C3.86502 11.2627 4.46271 10.665 5.20001 10.665C5.9373 10.665 6.535 11.2627 6.535 12Z"
      fill="white"
    />
    <path
      d="M14.7325 16.7328C15.371 16.3642 16.1875 16.583 16.5561 17.2215C16.9248 17.86 16.706 18.6765 16.0675 19.0451C15.429 19.4137 14.6125 19.195 14.2439 18.5565C13.8752 17.9179 14.094 17.1015 14.7325 16.7328Z"
      fill="white"
    />
    <path
      d="M14.4625 7.73486C13.9544 7.44153 13.6356 6.94634 13.5488 6.40909C13.0557 6.27282 12.5364 6.20001 12 6.20001C11.0718 6.20001 10.1944 6.41806 9.41649 6.80574L10.3694 8.45621C10.8655 8.22755 11.4179 8.10001 12 8.10001C14.0326 8.10001 15.702 9.65497 15.8836 11.6402H17.789C17.6987 10.1643 17.0564 8.83759 16.066 7.86386C15.5576 8.05666 14.97 8.02789 14.4625 7.73486Z"
      fill="white"
    />
    <path
      d="M12 17.8C12.5364 17.8 13.0558 17.7272 13.5488 17.5909C13.6356 17.0537 13.9545 16.5585 14.4625 16.2652C14.9701 15.9721 15.5577 15.9434 16.066 16.1362C17.0564 15.1624 17.6987 13.8357 17.789 12.3598H15.8836C15.702 14.345 14.0326 15.9 12 15.9C11.4179 15.9 10.8655 15.7725 10.3694 15.5438L9.41652 17.1943C10.1945 17.582 11.0718 17.8 12 17.8Z"
      fill="white"
    />
    <path
      d="M7.07503 12C7.07503 12.5866 6.80563 13.1104 6.38379 13.4542C6.74589 14.8567 7.61947 16.0535 8.79373 16.834L9.74661 15.1835C8.75024 14.477 8.09999 13.3144 8.09999 12C8.09999 10.6856 8.75023 9.52305 9.74659 8.81651L8.79371 7.16606C7.61946 7.94648 6.74588 9.14335 6.38379 10.5458C6.80563 10.8897 7.07503 11.4134 7.07503 12Z"
      fill="white"
    />
  </Icon>
));

export default UbuntuColor;
